import axiosPublicClient from "../../../../axiosPublicClient"

export default async (key) => {

    const result = await axiosPublicClient.get(`/pre-check-form-update-id?key=${key}`)

    return result.data

}
